"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionBarContext = exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _helpers = require("../utils/helpers");

var _ActionBarStyled = require("./ActionBar-styled");

var _CollapseAction = _interopRequireDefault(require("./CollapseAction"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ActionBarContext = (0, _react.createContext)({
  dark: undefined,
  position: undefined,
  collapsed: undefined
});
exports.ActionBarContext = ActionBarContext;
ActionBarContext.displayName = 'ActionBarContext';

var ActionBar = function ActionBar(_ref) {
  var children = _ref.children,
      dark = _ref.dark,
      position = _ref.position,
      showCollapser = _ref.showCollapser,
      collapsed = _ref.collapsed,
      collapseLabel = _ref.collapseLabel,
      expandLabel = _ref.expandLabel,
      onToggleCollapse = _ref.onToggleCollapse,
      other = _objectWithoutProperties(_ref, ["children", "dark", "position", "showCollapser", "collapsed", "collapseLabel", "expandLabel", "onToggleCollapse"]);

  var actionBarContext = (0, _helpers.useContextState)({
    dark: dark,
    position: position,
    collapsed: collapsed
  });
  return _react.default.createElement(ActionBarContext.Provider, {
    value: actionBarContext
  }, _react.default.createElement(_ActionBarStyled.StyledActionBar, _extends({
    dark: dark,
    position: position,
    collapsed: collapsed
  }, other), children, showCollapser && _react.default.createElement(_ActionBarStyled.StyledActionBarCollapseContainer, null, _react.default.createElement(_CollapseAction.default, {
    dark: dark,
    position: position,
    collapsed: collapsed,
    collapseLabel: collapseLabel,
    expandLabel: expandLabel,
    onClick: onToggleCollapse
  }))));
};

exports.default = ActionBar;
ActionBar.propTypes = {
  /** The content of the component; should be TabNav and TabContents. */
  children: _propTypes.default.node,

  /** Style prop to render a dark ActionBar. */
  dark: _propTypes.default.bool,

  /** Adjust alignment so ActionBar can be placed on the right side of the screen. */
  position: _propTypes.default.oneOf(['start', 'end']),

  /** Toggle visibility of the collapser control at the bottom of the ActionBar */
  showCollapser: _propTypes.default.bool,

  /** Programatically control collapsed state of the ActionBar */
  collapsed: _propTypes.default.bool,

  /** Label used in the collapser */
  collapseLabel: _propTypes.default.node,

  /** Label used in the collapser tooltip when collapsed */
  expandLabel: _propTypes.default.node,

  /** Event callback when the collapser is clicked */
  onToggleCollapse: _propTypes.default.func
};
ActionBar.defaultProps = {
  position: 'start',
  showCollapser: true,
  collapseLabel: 'Collapse',
  expandLabel: 'Expand',
  onToggleCollapse: function onToggleCollapse() {}
};
ActionBar.displayName = 'ActionBar';